export const errorsLabels: Record<string, string> = {
  required: 'Il campo è obbligatorio',
  min: 'Il valore del campo è minore del minimo consentito',
  max: 'Il valore del campo è maggiore del massimo consentito',
  number: 'Il valore del campo non è numerico',
  nextWorkingDay: 'La data selezionata non è un giorno feriale futuro.',
  date: 'La data selezionata non è valida',
  email: "L'email non è valida",
  twoLetters: 'Il valore del campo è maggiore della lunghezza massima consentita',
};
